// Dispatch message (preview): keep #Dispatch-<section id> in sync with the selected variant.
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  // While a new option is being fetched, hide the line so we never show a stale promise.
  // If the chosen combination doesn't exist the theme publishes no variantChange and the line stays hidden.
  subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function (event) {
    var target = event && event.data && event.data.target;
    var info = target && target.closest ? target.closest('product-info') : null;
    var scope = info || document;
    scope.querySelectorAll('.ae-dispatch').forEach(function (el) {
      el.classList.add('ae-dispatch--loading', 'hidden');
    });
  });

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var data = event && event.data;
    if (!data || !data.html) return;
    var id = 'Dispatch-' + data.sectionId;
    var source = data.html.getElementById(id);
    document.querySelectorAll('[id="' + id + '"]').forEach(function (dest) {
      if (source) {
        dest.innerHTML = source.innerHTML;
        dest.dataset.dispatchState = source.dataset.dispatchState || '';
        dest.dataset.variantId = source.dataset.variantId || '';
        dest.classList.toggle('hidden', source.classList.contains('hidden'));
      }
      dest.classList.remove('ae-dispatch--loading');
    });
  });
})();
